export default (app) => {
    app.general.addItem('smartlook', {
        enabled: false,
        id: '',
    });
};